const FENERGO_CONSTANTS = {  
    PUBLISHED: "Published",

    // UI Field types
    FIELDS: {
       SELECT: "select",
       MULTI_SELECT: "multiselect",
       SELECT_LINK: "selectLink",
       DATA_GROUP: "dataGroup"
    },

    // Journey tasks mapping
    JOURNEY_TASKS : {
        INDIVIDUAL_DETAILS : 'Individual Details'
    },

    // Journey Statuses
    JOURNEY_STATUSES : {
        IN_PROGRESS : 'In Progress',
        DONE: 'Done'
    },
  
    RELATED_PARTY_CATEGORIES: [
        'Related Party Basic Details',
        'Relationship Details',
        'Personal Information Required',
        'Identity Verification',
        //'Personal Information',
        // 'Related Party ID&V',
        // 'Real-Time ID&V Results',
        // 'Document Verification - ID&V Results'
    ],

    RELATED_PARTY_US_IDV_CATEGORIES: [
        'Identity document',
        'Address document',
        'SSN/ITIN document',
    ],

    RELATED_PARTY_UK_IDV_CATEGORIES: [
        'First government ID',
        'Second government ID',
        'Selfie document'
    ],

    ENTITY_IDV_FIELDS: [
        'entityLegalNameStatus',
        'eINStatus',
        'EntityPhysicalAddressStatus'
    ],

    US_ENTITY_IDV_FIELDS: [
        'entityLegalNameStatus',
        'eINStatus',
        'EntityPhysicalAddressStatus'
    ],

    NON_US_ENTITY_IDV_FIELDS: [
        'entityLegalNameStatus',
        'registeredNumberStatus',
        'EntityPhysicalAddressStatus'
    ],

    // Common IDV fields for both US and Non-US
    COMMON_IDV_FIELDS : {
        NAME_VERIFIED: { 
            VERIFY_FIELD : 'legalNameIDStatus', 
            RESPONSE_FIELDS: ['lastName', 'firstName'],
            DISPLAY_NAME : 'Legal Name',
            FORMATTER: 'name'
        },

        DOB_VERIFIED:  { 
            VERIFY_FIELD : 'dateOfBirthIDStatus', 
            RESPONSE_FIELDS: ['dateOfBirth'],
            DISPLAY_NAME : 'Date of Birth',
            FORMATTER: 'date'
        },

        ADDRESS_VERIFIED: {
            VERIFY_FIELD: 'residentialAddressIDStatus', 
            RESPONSE_FIELDS:  [
                'RPaddressLine1', 'RPcity', 
                'RPusState', 'RPprovinceTerritory', 'RPusStateMinorOutlyingIslands',  'RPstateCountyProvince', 
                'RPZipCode', 'RPpostalCodeCanada', 'RPpostalCodeUk', 'RPpostalCode',
            ],
            DISPLAY_NAME: 'Residential Address',
            FORMATTER: 'address'
        }
    },

    // US Specific IDV fields
    US_INDIVIDUAL_IDV: {
        ID_VERIFIED:  { 
            VERIFY_FIELD : 'ssnItinIDStatus', 
            RESPONSE_FIELDS: ['ssnItin'],
            DISPLAY_NAME : 'SSN / ITIN' 
        },
    },

    // Non-US Specific IDV fields
    NON_US_INDIVIDUAL_IDV: {
        ID_VERIFIED:  { 
            VERIFY_FIELD : 'governmentIdIDStatus', 
            RESPONSE_FIELDS: ['documentNumber'],
            DISPLAY_NAME : 'Government ID Number',
            FORMATTER: 'governmentId' 
        },
    },

    RESIDENTIAL_ADDRESS : {
        ADDRESS_LINE_1: 'RPaddressLine1',
        CITY: 'RPcity',
        STATE: [
            'RPusState', 'RPprovinceTerritory', 'RPusStateMinorOutlyingIslands',  'RPstateCountyProvince',        
        ],
        ZIP: [
            'RPZipCode', 'RPpostalCodeCanada', 'RPpostalCodeUk', 'RPpostalCode',
        ]
    },

    POLICY_FEILDS: {
        COUNTRIES_OF_CITIZENSHIP: 'countriesOfCitizenship',
        PROSPECT_BRANCH: 'fromWhichSvbBranchWillTheProspectRequireBankingServices',
        US_PROSPECT: 'SVB Silicon Valley Bank',
        UK_PROSPECT: 'SVB UK Branch'
    },

    //Company Common Registraion Verification Fields
    REGISTRATION_VERIFICATION_FILEDS : {
        COMPANY_NAME_VERIFIED : {
            VERIFY_FIELD : 'entityLegalNameStatus', 
            RESPONSE_FIELDS: ['companyLegalName'],
            DISPLAY_NAME : 'Legal Name',
            FORMATTER: 'companyName'
        }
    },

    // US Company Registration Address
    US_REGISTRATION_ADDRESS_FIELD : {
        ADDRESS_VERIFIED: {
            VERIFY_FIELD: 'EntityPhysicalAddressStatus', 
            RESPONSE_FIELDS:  [ 'addressLine1', "addressLine2", "city", "usState", "zipCode"],
            DISPLAY_NAME: 'Primary Address', 
            FORMATTER: 'companyPrimaryAddress'
        },
    },
    // UK Company Registration Address
    UK_REGISTRATION_ADDRESS_FIELD : {
        ADDRESS_VERIFIED: {
            VERIFY_FIELD: 'EntityPhysicalAddressStatus', 
            RESPONSE_FIELDS:  [ 'addressLine1', "addressLine2", "city", "stateCountyProvince", "postalCodeUk"],
            DISPLAY_NAME: 'Primary Address', 
            FORMATTER: 'companyPrimaryAddress'
        },
    },
    // Canada Company Registration Address
    CANADA_REGISTRATION_ADDRESS_FIELD : {
        ADDRESS_VERIFIED: {
            VERIFY_FIELD: 'EntityPhysicalAddressStatus', 
            RESPONSE_FIELDS:  [ 'addressLine1', "addressLine2", "city", "provinceTerritory", "postalCodeCanada"],
            DISPLAY_NAME: 'Primary Address', 
            FORMATTER: 'companyPrimaryAddress'
        },
    },

    // Other Country's Company Registration Address
    OTHER_COUNTRY_REGISTRATION_ADDRESS_FIELD : {
        ADDRESS_VERIFIED: {
            VERIFY_FIELD: 'EntityPhysicalAddressStatus', 
            RESPONSE_FIELDS:  [ 'addressLine1', "addressLine2", "city", "stateCountyProvince", "postalCode"],
            DISPLAY_NAME: 'Primary Address', 
            FORMATTER: 'companyPrimaryAddress'
        },
    },
    //US EIN Field
    US_EIN_REGISTRATION_FIELD: {
        EIN_VERIFIED: {
            VERIFY_FIELD: 'eINStatus', 
            RESPONSE_FIELDS:  [ 'employerIdentificationNumberEin'],
            DISPLAY_NAME: 'EIN', 
            FORMATTER: 'ein'
        }
    },
    US_EIN_REGISTRATION_PENDING_FIELD: {
        EIN_VERIFIED: {
            VERIFY_FIELD: 'eINStatus', 
            RESPONSE_FIELDS:  [ 'myEinIsPending'],
            DISPLAY_NAME: 'EIN', 
            FORMATTER: 'einPending',
            PENDING_VALUE: 'Yes'            
        }       
        
    },
    // Non-US EIN Field
    NON_US_EIN_REGISTRATION_FIELD: {
        EIN_VERIFIED: {
            VERIFY_FIELD: 'registeredNumberStatus', 
            RESPONSE_FIELDS:  [ 'registrationNumber'],
            DISPLAY_NAME: 'Registered Number', 
            FORMATTER: 'registrationNumber'
        }
    },

    // Country Names
    ENTITY_COUNTRY_FIELD: {
        COUNTRY_NAME: {
            UNITED_STATES: 'United States',
            UNITED_KINGDOM: 'United Kingdom',
            CANADA: 'Canada'
        }
    },

    // Formatted Response Value Fields
    FORMATTED_RESPONSE_FIELD: {
        ADDRESS: 'address',
        GOVERNMENT_ID: 'governmentId',
        COMPANY_NAME: 'companyName',
        EIN: 'ein',
        REGISTRATION_NUMBER: 'registrationNumber',
        COMPANY_PRIMARY_ADDRESS: 'companyPrimaryAddress',
        NAME: 'name',
        DATE: 'date',
        EIN_PENDING: 'einPending'
    },

    ADD_RELATED_INDIVIDUAL:{
        SEND_THE_LINK_FIELD: 'weNeedToGatherSensitiveInformationToVerifyTheirIdentityIfYouPreferToHaveThemFillOutThisSectionYouCanSendThemALink',
        SEND_THE_LINK_VALUE: "Send them a link",
        FILL_OUT_FOR_THEM: "Fill out for them"
    },

    APPLICANT_ROLE: "Applicant",
    GLOBAL_JUDISTRICTION: 'Global',
}

export default FENERGO_CONSTANTS;